import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component, EventEmitter, Inject,
  Input, OnChanges,
  OnDestroy,
  OnInit, Output, SimpleChanges,
  ViewChild
} from "@angular/core";
import {VisitPlanModel} from "../../../models/visit-plan.model";
import {PanelService} from "../../../../commons/angular/services/panel.service";
import {VisitPlanJobModel} from "../../../models/visit-plan-job.model";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {VisitPlanScheduleFacadeService} from "../../services/visit-plan-schedule-facade.service";
import {Subscription} from "rxjs";
import {
  VisitPlanScheduleResourceSelectListComponent
} from "../visit-plan-schedule-resource-select-list/visit-plan-schedule-resource-select-list.component";
import {SiteFiltersType} from "../../../../commons/types/site-filters.type";
import {
  VisitPlanJobsPanelFiltersDialogComponent
} from "../visit-plan-jobs-panel-filters-dialog/visit-plan-jobs-panel-filters-dialog.component";
import * as moment from "moment";
import {
  VisitPlanDaySelectDialogComponent
} from "../visit-plan-day-select-dialog/visit-plan-day-select-dialog.component";
import * as _ from "lodash";
import {CdkDragDrop} from "@angular/cdk/drag-drop";
import {VisitScheduleDayModel} from "../../../models/visit-schedule-day.model";
import {isVisitScheduleDayDispatchedById} from "../../../models/visit-schedule-day.functions";
import {EntityStoreService} from "../../../../commons/angular/services/entity-store.service";
import * as angular from "angular";
import {WidgetDatasourceEnum} from "../../../../dashboards/enums/widget-datasource.enum";


require('./visit-plan-jobs-panel.scss');
@Component({
  standalone: false,
  selector: 'app-visit-plan-jobs-panel',
  templateUrl: './visit-plan-jobs-panel.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisitPlanJobsPanelComponent implements OnInit, OnChanges, OnDestroy {

  @Input() visitPlan: VisitPlanModel;
  @Input() visitPlanRange?: {dateStart, dateEnd};
  @Input() panel: any;
  @Input() panels: any[];
  @Input() schedulingProjectJobs: any[];
  @Input() programTypeAliasMap: { [key: string]: string };
  @Input() schedulingProjectDays: VisitScheduleDayModel[];
  @Input() selectedIds: string[] = [];
  @Input() isReloadJobs: boolean = false;
  @Output() onCreateRoute = new EventEmitter<{ jobIds: string[], resourceId: string }>();
  @Output() onChangeSelectedIds = new EventEmitter<string[]>();
  @Output() onChangeDateRange = new EventEmitter<any>();
  @Output() onPanelChange = new EventEmitter<any>();
  @Output() onLockJobChange = new EventEmitter<{ id: string, locked: boolean }>();
  @Output() onClose = new EventEmitter();
  @Output() onAssign = new EventEmitter<{ event: Event, jobIds: string[], visitPlan: VisitPlanModel, dateRange?: { from: number, to: number }}>();

  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  jobs: VisitPlanJobModel[] = [];
  jobsSubscription: Subscription;
  isLoadingJobsSubscription: Subscription;
  entitiesSubscription: Subscription;
  selectedKeys: { [key: string]: boolean };
  // selectedIds: string[] = [];
  limit: number = 20;
  isLoading: boolean = false;
  // queryString: string;
  filtersConfig: any;
  public connectedPanelIds: string[];
  public dateRange: { from: number, to: number } | undefined = undefined;
  public isSelectedJobsDayDispatched: boolean = false;


  constructor(@Inject(PanelService) private panelService: PanelService, @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef,
              @Inject(VisitPlanScheduleFacadeService) private visitPlanScheduleFacadeService: VisitPlanScheduleFacadeService, @Inject(EntityStoreService) private entityStoreService: EntityStoreService<any>) {
  }

  ngOnInit() {

    this.entitiesSubscription = this.entityStoreService.entities$.subscribe(routes => {
      this.connectedPanelIds = _.concat(_.map(this.panels, 'id'), _.map(routes, 'id'));
    })

    if (!this.panel.filtersConfig) {
      this.panel.filtersConfig = {};
    }

    if (!this.panel.filtersConfig.range) {
      this.panel.filtersConfig.range = {
        dateStart: moment(this.visitPlanRange?.dateStart || this.visitPlan.from).startOf('day').valueOf(),
        dateEnd: moment(this.visitPlanRange?.dateStart || this.visitPlan.from).endOf('day').valueOf()
      }
    }

    if (!this.panel.filtersConfig.bringozFilters) {
      this.panel.filtersConfig.bringozFilters = {
        [SiteFiltersType.branchIds]: [],
        [SiteFiltersType.accountIds]: [],
        [SiteFiltersType.inRoute]: false
      }
    }

    this.selectedKeys = {};

    if (!!this.panel.filtersConfig?.range) {
      this.dateRange = {
        from: this.panel.filtersConfig.range.dateStart,
        to: this.panel.filtersConfig.range.dateEnd,
      };
    }

    this._getJobs();
    this.onPanelChange.emit(this.panel);

    this.jobsSubscription = this.visitPlanScheduleFacadeService.selectAllJobs().subscribe(jobs => {
      this.jobs = jobs;
      this.cdr.detectChanges();
      this.cdkVirtualScrollViewport?.checkViewportSize();
    })

    this.isLoadingJobsSubscription = this.visitPlanScheduleFacadeService.selectIsLoadingJobs()
      .subscribe(isLoading => {
        this.isLoading = isLoading;
        this.cdr.detectChanges();
      })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedIds) {
      this.initSelectedKeysMap();
      // this.selectedIds = Object.keys(this.selectedKeys).filter(key => this.selectedKeys[key]);
    }

    if (changes.isReloadJobs && !changes.isReloadJobs.isFirstChange()) {
      if (this.isReloadJobs) this._getJobs();
    }

    if (changes.panel && this.panel.filtersConfig.range) {
      this.dateRange = {
        from: this.panel.filtersConfig.range.dateStart,
        to: this.panel.filtersConfig.range.dateEnd,
      };
    }

    this._setIsSelectedJobsDayDispatched();
  }

  get blockedActionTooltipKey(): string {
    return this.isSelectedJobsDayDispatched ? 'VISIT_SCHEDULE_TOOLTIPS.ACTION_BLOCKED_CALL_DISPATCHED' : '';
  }

  private _setIsSelectedJobsDayDispatched() {
    this.isSelectedJobsDayDispatched = !!this.selectedIds?.some(jobId => {
      const job = _.find(this.schedulingProjectJobs, (j) => j.id === jobId);
      return isVisitScheduleDayDispatchedById(this.schedulingProjectDays, job?.visitScheduleDayId);
    });
  }

  ngOnDestroy() {
    this.jobsSubscription?.unsubscribe();
    this.isLoadingJobsSubscription?.unsubscribe();
    this.entitiesSubscription?.unsubscribe();
  }

  onQueryChange(queryString) {
    this.panel.filtersConfig.queryString = queryString;
    this._getJobs();
    this.onPanelChange.emit(this.panel);
  }

  onDatesBrowse(isNext: boolean) {
    const range = angular.copy(this.panel.filtersConfig.range);

    if (isNext) {
      range.dateStart = moment(range.dateStart).add(1, 'day').valueOf();
      range.dateEnd = moment(range.dateEnd).add(1, 'day').valueOf();
    } else {
      range.dateStart = moment(range.dateStart).subtract(1, 'day').valueOf()
      range.dateEnd = moment(range.dateEnd).subtract(1, 'day').valueOf()
    }

    if (range.dateStart < this.visitPlan.from) {
      range.dateStart = angular.copy(this.visitPlan.from);
    }

    if (range.dateEnd > this.visitPlan.to) {
      range.dateEnd = angular.copy(this.visitPlan.to);
    }

    this.panel.filtersConfig.range = range;

    this.dateRange = {
      from: range.dateStart,
      to: range.dateEnd,
    };
    this.selectedKeys = {};
    this.selectedIds = [];
    this.onChangeDateRange.emit(range);
    this.onChangeSelectedIds.emit(this.selectedIds);
    this._getJobs();
    this.onPanelChange.emit(this.panel);
  }

  isDateBrowseDisabled(date1, date2) {
    return moment(moment(date1).format("MM/DD/YYYY")).isSame(moment(date2).format("MM/DD/YYYY"));
  }


  // onDemandAccountsSelect(selectedIds) {
  //   this.panel.filtersConfig.bringozFilters[SiteFiltersType.accountIds] = selectedIds;
  //   this.getJobs();
  // }

  drop(event: CdkDragDrop<string[]>) {

    if (!event.isPointerOverContainer) {
      return false;
    }

    if (event.item.data.jobIds) {
      for (let jobId of event.item.data.jobIds) {
        const job = this.jobs.find((job) => job.id === jobId);
        if (!!job?.lockedRouteId) {
          return false;
        }
      }
    } else {
      const job = this.jobs.find((job) => job.id === event.item.data.jobId);
      if (!!job?.lockedRouteId) {
        return false;
      }
    }

    // this.onMoveToLeftovers.emit(event.item.data.jobIds || [event.item.data.jobId]);
    return false;

    // if (event.previousContainer === event.container) {
    //   moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    // } else {
    //   transferArrayItem(
    //     event.previousContainer.data,
    //     event.container.data,
    //     event.previousIndex,
    //     event.currentIndex
    //   );
    // }

  }

  onOpenDaySelectDialog(event) {
    const panel = this.panelService.open(VisitPlanDaySelectDialogComponent, event, {
      dateRange: this.visitPlanRange ?
        {from: this.visitPlanRange.dateStart, to: this.visitPlanRange.dateEnd} :
        {from: this.visitPlan.from, to: this.visitPlan.to},
      schedulingProjectDays: this.schedulingProjectDays,
      selectedDayTimestamp: this.panel.filtersConfig.range.dateStart,
      schedulingProjectJobs: this.schedulingProjectJobs,
      // scheduleDayId: this.panel.filtersConfig.scheduleDayId
    }, {
      position: {
        originX: 'start',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'top',
      },
      height: 370
    })

    if (panel) {
      panel.afterClose$.subscribe((timestamp) => {
        if (!!timestamp) {
          const rangeCopy = {...this.panel.filtersConfig.range};
          rangeCopy.dateStart = moment(timestamp).startOf('day').valueOf();
          rangeCopy.dateEnd = moment(timestamp).endOf('day').valueOf();
          this.panel.filtersConfig.range = rangeCopy;

          this.selectedKeys = {};
          this.selectedIds = [];
          this.onChangeDateRange.emit(rangeCopy);
          this.onChangeSelectedIds.emit(this.selectedIds);
          this._getJobs();
          this.onPanelChange.emit(this.panel);
        }
      })
    }
  }

  onToggleFilters(event) {
    const panel = this.panelService.open(VisitPlanJobsPanelFiltersDialogComponent, event, {
      visitPlan: this.visitPlan,
      filters: this.panel.filtersConfig.bringozFilters
    }, {
      position: {
        originX: 'start',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'top',
      },
      width: 300,
      height: 300
    })

    if (panel) {
      panel.afterClose$.subscribe((data) => {
        if (!!data) {
          this._onFilterChange(data);
          // this.cdr.detectChanges();
        }
      })
    }
  }


  getNextBatch() {
    if (this.cdkVirtualScrollViewport.measureScrollOffset('bottom') < 50 && !this.isLoading) {
      this.visitPlanScheduleFacadeService.fetchNextJobs(this.visitPlan.id, this.visitPlan.scheduleId, {
        limit: this.limit,
        from: this.panel.filtersConfig.range.dateStart,
        to: this.panel.filtersConfig.range.dateEnd,
        routed: false,
        query: this.panel.filtersConfig.queryString,
      });
    }
  }

  // onToggleSelectAll() {
  //   this.onSelectOrdersChanged.emit({
  //     selectedIds: [],
  //     excludeMode: !this.excludeMode
  //   });
  // }


  onToggleJobSelect(jobId: string) {
    this.selectedKeys[jobId] = !this.selectedKeys[jobId];
    this.selectedIds = Object.keys(this.selectedKeys).filter(key => this.selectedKeys[key]);
    this.onChangeSelectedIds.emit(this.selectedIds);
  }

  private _onFilterChange(filters) {
    this.panel.filtersConfig.bringozFilters = filters;
    this._getJobs();
    this.onPanelChange.emit(this.panel);
  }

  private _getJobs() {
    this.visitPlanScheduleFacadeService.clearStore();
    this.visitPlanScheduleFacadeService.getManyJobs(this.visitPlan.id, this.visitPlan.scheduleId, this._getQueryParams());
  }

  private _getQueryParams() {
    const params = {
      limit: this.limit,
      routed: this.panel.filtersConfig.bringozFilters[SiteFiltersType.inRoute],
      accountIds: this.panel.filtersConfig.bringozFilters[SiteFiltersType.accountIds],
      projectBranchIds: this.panel.filtersConfig.bringozFilters[SiteFiltersType.branchIds],
      from: this.panel.filtersConfig.range.dateStart,
      to: this.panel.filtersConfig.range.dateEnd,
      query: this.panel.filtersConfig.queryString,
    }
    Object.keys(params).forEach(key => params[key] === undefined && delete params[key]);
    return params;
  }

  private initSelectedKeysMap() {
    this.selectedKeys = {};
    _.forEach(this.selectedIds, (selectedId) => {
      this.selectedKeys[selectedId] = true;
    });
  }

  protected readonly widgetDataSourceType = WidgetDatasourceEnum;
}
